export function parseAuthenticatorVersion(
  versionString: string | undefined,
  exact = false,
  matchPrefix = 'mobile-v?',
) {
  const pattern = new RegExp(
    `${exact ? '^' : ''}${matchPrefix}(0|[1-9]\\d*)(?:\\.(0|[1-9]\\d*))?(?:\\.(0|[1-9]\\d*))?${exact ? '$' : ''}`,
  );
  const match = versionString?.match?.(pattern);
  if (match) {
    return match.slice(1).map((part: string) => Number(part) || 0);
  }
  return null;
}

export function compareAuthenticatorVersions(
  versionA: number[] | unknown,
  versionB: number[] | unknown,
) {
  const arrayA = Array.isArray(versionA) ? versionA : [];
  const arrayB = Array.isArray(versionB) ? versionB : [];

  for (let i = 0; i < 3; i++) {
    const a = Number(arrayA[i]) || 0;
    const b = Number(arrayB[i]) || 0;
    if (a - b !== 0) {
      return (a - b) * 1000 ** (2 - i);
    }
  }
  return 0;
}

export default function isAuthenticatorVersionSupported(
  deviceVersionString?: string,
  minVersionStrings?: (string | undefined)[],
) {
  if (!deviceVersionString) {
    // If version is unspecified, assume supported
    return true;
  }

  const minVersions = (minVersionStrings || [])
    .map((minVersionString) =>
      parseAuthenticatorVersion(minVersionString, false, ''),
    )
    .filter(Boolean) as number[][];
  if (!minVersions.length) {
    // No version restrictions
    return true;
  }

  const deviceVersion = parseAuthenticatorVersion(deviceVersionString);
  if (!deviceVersion) {
    // If version string is invalid that’s a failure
    return false;
  }

  const minVersion = minVersions.reduce((prev, next) => {
    if (!prev || compareAuthenticatorVersions(next, prev) > 0) {
      return next;
    }
    return prev;
  });

  return compareAuthenticatorVersions(deviceVersion, minVersion) >= 0;
}
